import React, { useState, useEffect } from 'react';
import axios from 'axios';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import Fab from '@material-ui/core/Fab';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import RemoveCircleOutlinedIcon from '@material-ui/icons/RemoveCircleOutlined';
import AttachFileOutlinedIcon from '@material-ui/icons/AttachFileOutlined';
import ConfirmationNumberOutlinedIcon from '@material-ui/icons/ConfirmationNumberOutlined';
import LabelOutlinedIcon from '@material-ui/icons/LabelOutlined';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import LocalCafeOutlinedIcon from '@material-ui/icons/LocalCafeOutlined';
import FastfoodOutlinedIcon from '@material-ui/icons/FastfoodOutlined';
import ScheduleOutlinedIcon from '@material-ui/icons/ScheduleOutlined';
import ExtensionOutlinedIcon from '@material-ui/icons/ExtensionOutlined';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware';
import CustomSelect from '../custom-select';

const HotelMeetingForm = ({ index, coffeeBreakUpload, lunchUpload, attachmentUpload, onCoffeeBreakChange, onLunchChange, onAttachmentChange }) => {
    const [equipment, setEquipment] = useState(null);
    const [, setError] = useState(null);
    const [user] = useState(checkTokenExpirationMiddleware());
    const [addRow, setAddRow] = useState([]);

    const appendRow = () => {
        let rows = [...addRow];
        rows.push(1);
        setAddRow(rows);
    };

    const removeRow = () => {
        let rows = [...addRow];
        rows.pop();
        setAddRow(rows);
    };

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };
    useEffect(() => {
        axios.get("/api/equipment", { headers: headers })
            .then(res => { setEquipment(res.data); })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, []);

    return (
        <>
            <Grid
                container
                spacing={1}
                style={{ margin: `15px`, padding: `15px` }}
                className="ho-me"
            >
                <Grid container item xs={12} spacing={2}>
                    <Typography variant="subtitle2" gutterBottom>
                        Meeting Rooms Details
                    </Typography>
                </Grid>

                <Grid container item xs={12} spacing={2}>
                    <Grid item sm={4} md={4} lg={4}>
                        <TextField
                            label={"Meeting Date"}
                            fullWidth
                            required
                            type={"date"}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <EventOutlinedIcon fontSize={"small"} />
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item sm={4} md={4} lg={4}>
                        <TextField
                            label={"Meeting Time"}
                            fullWidth
                            required
                            type={"time"}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <ScheduleOutlinedIcon fontSize={"small"} />
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item sm={4} md={4} lg={4}>
                        <TextField
                            label={"Room Setup"}
                            fullWidth
                            required
                            type={"text"}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <ExtensionOutlinedIcon fontSize={"small"} />
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                </Grid>

                <Grid container item xs={12} spacing={2}>
                    <Grid item sm={12} md={6} lg={6}>
                        {/*<TextField
                            label="Coffee Break Menu"
                            multiline
                            fullWidth
                            rows={2}
                            variant="outlined"
                        />*/}
                        <input
                            accept=".jpg,.jpeg,.png,.bmp,.gif,.pdf,.doc,.docx,.xls,.pptx,.xlsx"
                            style={{ display: `none` }}
                            id={`coffe-attach-${index}`}
                            className="coffe-attach"
                            type="file"
                            onChange={onCoffeeBreakChange}
                        />
                        <label htmlFor={`coffe-attach-${index}`}>
                            <Button variant="outlined" color="primary" component="span">
                                Coffee Break Menu
                            </Button>
                        </label>
                        {
                            coffeeBreakUpload && coffeeBreakUpload.uploading ?
                                <div style={{ marginTop: "8px" }}>Uploading menu...</div>
                                : null
                        }
                        {
                            coffeeBreakUpload && coffeeBreakUpload.originalFileName ?
                                <div style={{ marginTop: "8px" }}>{coffeeBreakUpload.originalFileName}</div>
                                : null
                        }
                    </Grid>
                    <Grid item sm={6} md={3} lg={3}>
                        <TextField
                            label={"Coffee Break Time"}
                            fullWidth
                            type={"time"}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LocalCafeOutlinedIcon fontSize={"small"} />
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item sm={6} md={3} lg={3}>
                        <TextField
                            label={"Coffee Break Price/Person"}
                            fullWidth
                            type={"number"}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LocalAtmIcon fontSize={"small"} />
                                    </InputAdornment>
                                ),
                                inputProps: { min: 1 }
                            }}
                        />
                    </Grid>
                </Grid>

                <Grid container item xs={12} spacing={2}>
                    <Grid item sm={12} md={6} lg={6}>
                        {/*<TextField
                            label="Lunch/Dinner Break Menu"
                            multiline
                            fullWidth
                            rows={2}
                            variant="outlined"
                        />*/}
                        <input
                            accept=".jpg,.jpeg,.png,.bmp,.gif,.pdf,.doc,.docx,.xls,.pptx,.xlsx"
                            style={{ display: `none` }}
                            id={`meal-attach-${index}`}
                            className="meal-attach"
                            type="file"
                            onChange={onLunchChange}
                        />
                        <label htmlFor={`meal-attach-${index}`}>
                            <Button variant="outlined" color="primary" component="span">
                                Lunch/Dinner Break Menu
                            </Button>
                        </label>
                        {
                            lunchUpload && lunchUpload.uploading ?
                                <div style={{ marginTop: "8px" }}>Uploading menu...</div>
                                : null
                        }
                        {
                            lunchUpload && lunchUpload.originalFileName ?
                                <div style={{ marginTop: "8px" }}>{lunchUpload.originalFileName}</div>
                                : null
                        }
                    </Grid>
                    <Grid item sm={6} md={3} lg={3}>
                        <TextField
                            label={"Lunch/Dinner Break Time"}
                            fullWidth
                            type={"time"}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FastfoodOutlinedIcon fontSize={"small"} />
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item sm={6} md={3} lg={3}>
                        <TextField
                            label={"Lunch/Dinner Break Price/Person"}
                            fullWidth
                            type={"number"}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LocalAtmIcon fontSize={"small"} />
                                    </InputAdornment>
                                ),
                                inputProps: { min: 1 }
                            }}
                        />
                    </Grid>
                </Grid>

                <Grid container item xs={12} spacing={2}>
                    <Grid item sm={6} md={4} lg={4}>
                        <TextField
                            label={"Meeting Room Name"}
                            fullWidth
                            required
                            type={"text"}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LabelOutlinedIcon fontSize={"small"} />
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item sm={6} md={4} lg={4}>
                        <TextField
                            label={"Meeting Room Max Capacity"}
                            fullWidth
                            required
                            type={"number"}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <PeopleAltOutlinedIcon fontSize={"small"} />
                                    </InputAdornment>
                                ),
                                inputProps: { min: 1 }
                            }}
                        />
                    </Grid>
                    <Grid item sm={6} md={4} lg={4}>
                        <TextField
                            label={"Meeting Package Price/Person"}
                            fullWidth
                            required
                            type={"number"}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LocalAtmIcon fontSize={"small"} />
                                    </InputAdornment>
                                ),
                                inputProps: { min: 1 }
                            }}
                        />
                    </Grid>
                </Grid>

                {
                    addRow.length > 0 ?
                        <Grid container item xs={12} spacing={2} style={{
                            border: `solid 1px black`,
                            padding: `4px`,
                            marginTop: `15px`
                        }}>
                            {
                                addRow.map((item, index) =>
                                    <EquipmentRow
                                        key={index}
                                        extra={true}
                                        equipment={equipment}
                                        removeRow={removeRow}
                                    />
                                )
                            }
                        </Grid>
                        : null
                }

                <Grid container justify="flex-end">
                    <Tooltip title="Add Meeting Equipment" placement="left">
                        <Fab size="small" color="primary" aria-label="add" onClick={appendRow}>
                            <AddIcon />
                        </Fab>
                    </Tooltip>
                </Grid>

                <Grid container item xs={12} spacing={2}>
                    <Grid item sm={12} md={6} lg={3}>
                        <TextField
                            label="Payment Policy"
                            multiline
                            fullWidth
                            required
                            rows={3}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item sm={12} md={6} lg={3}>
                        <TextField
                            label="Cancellation Policy"
                            multiline
                            fullWidth
                            required
                            rows={3}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item sm={12} md={6} lg={2}>
                        <TextField
                            label="Free Policy"
                            multiline
                            fullWidth
                            required
                            rows={3}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item sm={12} md={6} lg={2}>
                        <TextField
                            label="Notes"
                            multiline
                            fullWidth
                            rows={3}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item sm={6} md={4} lg={2}>
                        <input
                            accept=".jpg,.jpeg,.png,.bmp,.gif,.pdf,.doc,.docx,.xls,.pptx,.xlsx"
                            style={{ display: `none` }}
                            id={`file-attach-${index}`}
                            className="file-attach"
                            type="file"
                            onChange={onAttachmentChange}
                        />
                        <label htmlFor={`file-attach-${index}`}>
                            <Button variant="outlined" color="primary" component="span">
                                Attachment
                            </Button>
                        </label>
                        {
                            attachmentUpload && attachmentUpload.uploading ?
                                <div style={{ marginTop: "8px" }}>Uploading attachment...</div>
                                : null
                        }
                        {
                            attachmentUpload && attachmentUpload.originalFileName ?
                                <div style={{ marginTop: "8px" }}>{attachmentUpload.originalFileName}</div>
                                : null
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

const EquipmentRow = ({ equipment, removeRow, extra }) => {
    return (
        <Grid container item xs={12} spacing={2} className="eq-rw">
            <Grid item sm={6} md={3} lg={3}>
                <CustomSelect
                    data={equipment}
                    label={"Equipment"}
                    required={true}
                    icon={<AttachFileOutlinedIcon fontSize={"small"} />}
                />
            </Grid>
            <Grid item sm={6} md={3} lg={3}>
                <TextField
                    label={"Avaliable Items"}
                    fullWidth
                    type={"number"}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <ConfirmationNumberOutlinedIcon fontSize={"small"} />
                            </InputAdornment>
                        ),
                        inputProps: { min: 1 }
                    }}
                    required
                />
            </Grid>
            <Grid item sm={6} md={3} lg={3}>
                <TextField
                    label={"Price/Item"}
                    fullWidth
                    type={"number"}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <LocalAtmIcon fontSize={"small"} />
                            </InputAdornment>
                        ),
                        inputProps: { min: 1 }
                    }}
                    required
                />

            </Grid>
            {
                extra === true ?
                    <Grid item sm={1} md={1} lg={1}>
                        <RemoveCircleOutlinedIcon color="error" fontSize="small" onClick={() => removeRow()} />
                    </Grid>
                    :
                    null
            }
        </Grid>
    )
};

export default HotelMeetingForm;
